import { z } from 'zod';

export const StripePortalDetailsSchema = z.object({
  configuration: z.string(),
  created: z.number(),
  customer: z.string(),
  flow: z.string().nullable(),
  id: z.string(),
  livemode: z.boolean(),
  locale: z.string().nullable(),
  object: z.string(),
  on_behalf_of: z.string().nullable(),
  return_url: z.string(),
  url: z.string(),
});

export type StripePortalDetailsData = z.infer<typeof StripePortalDetailsSchema>;
